export default __webpack_public_path__ + "static/netatlantic-3740fad3fa4fb7f5c9680eb58b3f69e2.png";